import { ModuleName } from "../Lib/AxSystem/AxInit";
import { AxAlert } from "./AxAlert/AxAlert";
import { AxButton } from "./AxButton/AxButton";
import { AxPortletExpandable } from "./AxPortlet/AxPortletExpandable";
import { AxTab } from "./AxPortlet/AxTab";

@ModuleName("AxLimeStone")
export class AxLimeStone {
    private TabHandler: AxTab[] = [];

    constructor(private _AxButton = new AxButton(),
        private _AxPortletExpandable = new AxPortletExpandable()) { }

    public Init() {
        let portletTabHandler = new AxTab();
        this.TabHandler.push(portletTabHandler);

        portletTabHandler.Init();
        this._AxPortletExpandable.Init();
        window.addEventListener("pageshow", this.WindowListener.bind(this));
    }

    WindowListener(event: PageTransitionEvent) {
        if (event.persisted) {
            this.UnlockAllButtons();
        }
    }

    public Alert(selector: string): void {
        new AxAlert(selector);
    }

    public LockButton(e: HTMLElement, classes: string = '') {
        this._AxButton.Loading(e, classes);
    }

    public UnlockButton(e: HTMLElement, classes: string = '') {
        this._AxButton.StopLoading(e, classes);
    }

    public UnlockAllButtons(classes: string = '') {
        let buttons = document.querySelectorAll('.ax-btn.ax-loading');

        buttons.forEach((currentValue, currentIndex, listObj) => {
            this._AxButton.StopLoading(currentValue as HTMLElement, classes);
        });
    }
}